import React from "react";
import '../styles/Header.css';




function Header() {
  return (
    <header className="bg-dark text-white py-4">
      <div className="container text-center">
        <h1>Todo List Application</h1>
      </div>
    </header>
  );
}

export default Header;
